import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { GlobalTagForm } from './GlobalTagForm';

type Props = {
  id?: string;
  open: boolean;
  onClose: () => void;
} & ComponentProps<typeof GlobalTagForm>;

export const GlobalTagFormDrawer: FC<Props> = ({
  id,
  open,
  onClose,
  ...formProps
}) => {
  return (
    <Drawer open={open} onClose={onClose} destroyOnClose>
      <GlobalTagForm {...formProps} />
    </Drawer>
  );
};
